import React, {useState} from 'react'
import {Button, Dimmer, Form, Header, Icon, Loader, Message} from "semantic-ui-react";

import SimpleReactValidator from 'simple-react-validator';

const EmailResend = (props) => {
    const [errorString, setError] = useState();
    const [emailAddress, setEmailAddress] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [firstNameError, setFirstNameError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const validator = new SimpleReactValidator();

    const submitForm = (e) =>
    {
        setError();
        setEmailError();
        setFirstNameError();
        setLastNameError();

        let hasErrors = false;

        if (!validator.check(emailAddress, 'required|email'))
        {
            setEmailError(true);
            hasErrors = true;
        }

        if (!hasErrors)
        {
            setLoading(true);
            props.dataManager.resendEmail(emailAddress, firstName, lastName)
                .then(response => {
                    setLoading(false);
                    console.log(response);
                    if (typeof response.data.success !== "undefined") {
                        if (response.data.success == 0) {
                            setError(response.data.errorMessage);
                        } else {
                            setSuccess(true);
                        }
                    }
                    else
                    {
                        setError(response.data);
                        setLoading(false);
                    }
                });
        }
        else
        {
            setError("Please review the fields marked below.")
        }
    }


    return (
        <div>
            <Dimmer active={loading} inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>

            <Header as='h2' style={{marginTop: 0}}>Email Validation Re-Send Request</Header>
            <div>If you have not yet received a validation email, please complete the form below to have it resent. You must use the exact same information provided during registration.
                <br />
                <br />
                Please note that some email software automatically moves email messages into a "Spam" or "Junk email" folder. Please check to see if the Validation
                email got placed in one of those folders. If so, please right-click on the message to add the sender to your "Safe Senders List".
                If your email provider provides a "whitelist" function, please add the following email Address to the list: &#110;&#111;&#116;&#105;&#102;&#105;&#099;&#097;&#116;&#105;&#111;&#110;&#115;&#064;&#105;&#097;&#116;&#102;&#097;&#100;&#112;&#046;&#099;&#111;&#109;
            </div>

            { (typeof errorString !== "undefined") &&
            <Message error icon>
                <Icon name='exclamation' />
                <Message.Content>
                    <Message.Header>An error occurred</Message.Header>
                    {errorString}
                </Message.Content>
            </Message>
            }

            { (success) &&
            <Message success icon>
                <Icon name='check' />
                <Message.Content>
                    <Message.Header>Email Sent</Message.Header>
                    It may take 15 to 30 minutes for the email to show up in your inbox.
                </Message.Content>
            </Message>
            }

            <Form size='large' style={{marginTop: '2em'}} onSubmit={submitForm}>
                <Form.Group widths='equal'>
                    <Form.Field required label="First (Given) Name:" control="input" value={firstName} onChange={(e) => setFirstName(e.target.value)} error={firstNameError} />
                    <Form.Field required label="Last (Family) Name:" control="input" value={lastName} onChange={(e) => setLastName(e.target.value)} error={lastNameError} />
                </Form.Group>
                <Form.Field required label="Email Address" control="Input" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} placeholder="user@domain.com" error={emailError} />
                <Button type='submit'>Request Re-send</Button>
            </Form>
            <br /><p><a href="#" onClick={(e) => { props.setStep("validate");}}>Return to Validation Page</a></p>
        </div>
    )
}

export default EmailResend;